import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { SxProps, Theme } from "@mui/material/styles";
import { useStyles } from "./Common.styles";

export interface DisabledRule {
	when: boolean;
	message?: React.ReactNode;
}

interface LargeActionButtonProps {
	disabled?: boolean;
	disabledMessage?: React.ReactNode;
	disabledRules?: DisabledRule[];
	variant?: "contained" | "outlined" | "text";
	className?: string;
	sx?: SxProps<Theme>;
	onClick: () => void;
	children: React.ReactNode;
}

export const LargeActionButton = ({
	disabled,
	disabledMessage,
	disabledRules,
	variant = "contained",
	className,
	sx,
	onClick,
	children,
}: LargeActionButtonProps) => {
	const classes = useStyles();
	const cssClass = className ?? "";
	const activeRule = disabledRules?.find((rule) => rule.when);
	const isDisabled = disabled || activeRule !== undefined;
	const message = activeRule?.message ?? disabledMessage;

	const button = (
		<Button
			variant={variant}
			disableRipple
			className={`${classes.customButton} ${cssClass}`}
			onClick={onClick}
			disabled={isDisabled}
			sx={sx}
			classes={{
				contained: classes.contained,
				outlined: classes.outlined,
			}}
		>
			{children}
		</Button>
	);

	if (!disabledMessage && !disabledRules) {
		return button;
	}

	return (
		<Box sx={{ width: "100%" }}>
			{isDisabled && message && (
				<Typography variant="caption" display="block" align="center" color="text.secondary">
					{message}
				</Typography>
			)}
			{button}
		</Box>
	);
};
